(function () {
  angular
    .module('specsguardApp')
    .directive('sgTableCheckboxFilter', sgTableCheckboxFilter);

  sgTableCheckboxFilter.$inject = [];

  function sgTableCheckboxFilter () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/components/sg-mat-table/sg-table-checkbox-filter/sg-table-checkbox-filter.html'
    };
  };
})();
